// extracted by mini-css-extract-plugin
export default {"dropdown__subtitle":"DropdownSubtitle_dropdown__subtitle__5KNgw"};